import {dispatchStateContext, globalStateContext} from '@/App.jsx';
import React, {lazy, useEffect, useMemo, useState} from 'react';
import {ReactNotifications} from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import {useNavigate, useParams} from 'react-router-dom';
import BottomNavBar from '../components/web/BottomNavBar.jsx';
import Header from '../components/web/largeScreen/header/Header.jsx';
import Logo from '../components/web/largeScreen/header/Logo.jsx';
import Menu from '../components/web/largeScreen/header/Menu.jsx';
import Navbar from '../components/web/Navbar.jsx';
import {getToday, isUserAdvisor} from '../services/utility.js';
import {
  MinFullHeightView,
  MyView,
  PhoneContentConianerStyle,
  PhoneContentConianerStyle2,
} from '../styles/CommonComponents.jsx';

const Home = lazy(() => import('./general/home/Home.jsx'));
const Login = lazy(() => import('./general/login/Login.jsx'));
const WebLogin = lazy(() => import('./general/login/web/Login'));
const WebProfile = lazy(() => import('./general/profile/web/Profile'));

const PageNotFound = lazy(() => import('./general/404/PageNotFound'));
const Dashboard = lazy(() => import('./studentPanel/dashboard/Dashboard'));

const AdvisorDashboard = lazy(() =>
  import('./advisorPanel/dashboard/Dashboard'),
);

const Ticketstd = lazy(() => import('./studentPanel/ticket/Ticket'));
const Upgrade = lazy(() => import('./studentPanel/upgrade/Upgrade'));

const SchoolUsers = lazy(() => import('./agentPanel/schools/Schools.jsx'));
const AcceptInvite = lazy(() => import('./singlePages/AcceptInvite'));
const Teachers = lazy(() => import('./teacher/teachers/Teachers'));

const Buy = lazy(() => import('./general/buy/Buy'));
const BuyIndividual = lazy(() => import('./general/buy/BuyIndividual'));
const MyIRYSCQuizzes = lazy(() =>
  import('./studentPanel/myQuizzes/irysc/MyQuizzes'),
);
const MyCustomQuizzes = lazy(() =>
  import('./studentPanel/myQuizzes/custom/MyQuizzes'),
);
const MySchoolQuizzes = lazy(() => import('./schoolPanel/myQuizzes/MyQuizzes'));
const ChargeAccount = lazy(() =>
  import('./studentPanel/chargeAccount/ChargeAccount'),
);
const RunQuiz = lazy(() => import('./studentPanel/runQuiz/RunQuiz'));
const MyOffs = lazy(() => import('./studentPanel/myOffs/MyOffs'));
const ManageStudents = lazy(() =>
  import('./schoolPanel/manageStudents/ManageStudents'),
);
const ManageTeachers = lazy(() =>
  import('./schoolPanel/manageTeachers/ManageTeachers'),
);
const Invoice = lazy(() => import('./schoolPanel/invoice/Invoice'));
const RankingList = lazy(() => import('./general/rankingList/RankingList'));
const MakeQuiz = lazy(() => import('./studentPanel/makeQuiz/MakeQuiz'));
const History = lazy(() => import('./studentPanel/history/History'));
const ShowRecp = lazy(() => import('./studentPanel/recp/ShowRecp'));
const Packages = lazy(() => import('./general/packages/Packages'));

const CheckCert = lazy(() => import('./general/checkCert/CheckCert'));
const MyCerts = lazy(() => import('./general/checkCert/MyCerts'));

const SingleNotif = lazy(() => import('./studentPanel/notif/Notif'));
const Videos = lazy(() => import('./general/videos/Videos.jsx'));
const VideoDetail = lazy(() =>
  import('./general/videos/components/Detail.jsx'),
);
const UserVideos = lazy(() => import('./general/userVideos/UserVideos.jsx'));

import {LargeContentConianer} from '@/styles/common/LargeContentConianer.jsx';
import {useTheme} from 'styled-components';
import {routes} from '../api/apiRoutes';
import {generalRequest} from '../api/utility.js';
import {QuizProvider} from '@/basic/quiz/Context.jsx';

const Components = lazy(() => import('./general/components/Components'));
const ContentQuizKarname = lazy(() =>
  import('@/basic/quiz/reports/karname/ContentQuizKarname.jsx'),
);
const CourseList = lazy(() => import('./general/courseList/CourseList'));

const ShowScheduleByUrlForStudent = lazy(() =>
  import('./advisorPanel/schedule/components/ShowScheduleByUrlForStudent.jsx'),
);
const ShowScheduleByUrlForAdvisor = lazy(() =>
  import('./advisorPanel/schedule/components/ShowScheduleByUrlForAdvisor.jsx'),
);
const MyAdvisorHistory = lazy(() =>
  import('./studentPanel/advisor/myAdvisor/MyAdvisorHistory'),
);
const TeacherProfile = lazy(() =>
  import('./advisorPanel/profile/TeacherProfile'),
);
const StudentProfile = lazy(() =>
  import('./studentPanel/profile/StudentProfile'),
);
const MyTeachSchedule = lazy(() =>
  import('./advisorPanel/teach/schedule/MyTeachSchedule'),
);
const Schools = lazy(() => import('./schools/Schools.jsx'));
const MyTeachTransactions = lazy(() =>
  import('./advisorPanel/teach/transaction/MyTeachTransactions'),
);
const MyTeachRequests = lazy(() =>
  import('./advisorPanel/teach/requests/MyTeachRequests'),
);
const MyScheduleRequests = lazy(() =>
  import('./studentPanel/teach/myScheduleRequests/MyScheduleRequests'),
);
const MyTeachClasses = lazy(() =>
  import('./studentPanel/teach/myClasses/MyClasses'),
);
const SessionDetail = lazy(() =>
  import('./general/packages/components/detail/SessionDetail'),
);
const AnswerSheet = lazy(() => import('./general/corrector/AnswerSheet'));
const MyTasks = lazy(() => import('./correctorPanel/myTasks/MyTasks'));
const MyQuizzes = lazy(() =>
  import('./studentPanel/myQuizzes/school/MyQuizzes'),
);
const MyComments = lazy(() => import('./studentPanel/comment/MyComments'));
const CommentsAboutMe = lazy(() =>
  import('./studentPanel/comment/CommentsAboutMe'),
);
const Advisors = lazy(() => import('./general/advisors/Advisors'));
const AdvisorsBeforeLogin = lazy(() =>
  import('./general/advisors/AdvisorsBeforeLogin'),
);
const AllTeachers = lazy(() => import('./general/teachers/Teachers'));
const RequestLogsForAdvisors = lazy(() =>
  import('./studentPanel/requestLogsForAdvisors/RequestLogsForAdvisors'),
);
const MyRequests = lazy(() => import('./advisorPanel/myRequests/MyRequests'));
const MyAdvisor = lazy(() =>
  import('./studentPanel/advisor/myAdvisor/MyAdvisor'),
);
const MyHWs = lazy(() => import('./schoolPanel/myHWs/MyHWs'));
const StudentHWs = lazy(() => import('./studentPanel/myQuizzes/hw/MyHWs'));
const DoHW = lazy(() => import('./studentPanel/myQuizzes/doHW/DoHW.jsx'));
const BuyOnlineStanding = lazy(() => import('./general/buy/BuyOnlineStanding'));
const RunOnlineStandingQuiz = lazy(() =>
  import('./studentPanel/runOnlineStandingQuiz/RunOnlineStandingQuiz'),
);
const MyLifeStyle = lazy(() =>
  import('./studentPanel/myLifeStyle/MyLifeStyle.jsx'),
);
const RunEscapeQuiz = lazy(() =>
  import('./studentPanel/runEscapeQuiz/RunEscapeQuiz'),
);
const Ranking = lazy(() => import('./general/onlineStanding/Ranking'));
const PublicBadges = lazy(() => import('./general/badge/Badge'));
const MyFinancePlans = lazy(() =>
  import('./advisorPanel/myFinancePlans/MyFinancePlans'),
);
const ChatRoom = lazy(() => import('./studentPanel/chat/ChatRoom'));
const ProfileConfig = lazy(() =>
  import('./studentPanel/profileConfig/ProfileConfig'),
);
const Schedule = lazy(() => import('./advisorPanel/schedule/Schedule'));
const Progress = lazy(() => import('./advisorPanel/progress/Progress'));
const RunPDFQuiz = lazy(() => import('./studentPanel/runPDFQuiz/RunPDFQuiz'));

const WebStructue = props => {
  const navigate = useNavigate();
  const useGlobalState = () => [
    React.useContext(globalStateContext),
    React.useContext(dispatchStateContext),
  ];
  const [state, dispatch] = useGlobalState();
  const [allowRenderPage, setAllowRenderPage] = useState(false);
  const includeFilterMenu = ['buy', 'quiz'];
  const excludeBottomNav = ['buy'];
  const [isWorking, setIsWorking] = useState(false);
  const [canRequestForAdv, setCanRequestForAdv] = useState(
    window.localStorage.getItem('can_request_for_adv'),
  );
  useEffect(() => {
    setCanRequestForAdv(window.localStorage.getItem('can_request_for_adv'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.localStorage]);
  const [lastFetchDailyAdv, today] = useMemo(
    () => [window.localStorage.getItem('last_fetch_daily_adv'), getToday()],
    [],
  );
  const fetchCanReq = React.useCallback(() => {
    window.localStorage.setItem('can_request_for_adv', undefined);
    Promise.all([
      generalRequest(
        routes.canReqForAdv,
        'get',
        undefined,
        'data',
        state.token,
      ),
    ]).then(res => {
      if (res[0] != null) {
        window.localStorage.setItem('last_fetch_daily_adv', today);
        window.localStorage.setItem('can_request_for_adv', res[0]);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.token]);
  useEffect(() => {
    if (state.token && today !== lastFetchDailyAdv) fetchCanReq();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastFetchDailyAdv, state.token]);
  React.useEffect(() => {
    setAllowRenderPage(state.user !== undefined);
  }, [state.user]);
  React.useEffect(() => {
    fetchAlerts();
  }, [state.user, fetchAlerts]);
  const [myAlerts, setMyAlerts] = useState();
  React.useEffect(() => {
    setMyAlerts(state.newAlerts);
  }, [state.newAlerts]);
  const fetchAlerts = React.useCallback(() => {
    if (
      !isWorking &&
      state.newAlerts === undefined &&
      state.token !== null &&
      state.token !== undefined &&
      state.user !== null &&
      state.user !== undefined
      // (userTmp.accesses.indexOf('admin') !== -1 ||
      //   userTmp.accesses.indexOf('superadmin') !== -1)
    ) {
      setIsWorking(true);
      Promise.all([
        generalRequest(
          routes.getMyAlerts,
          'get',
          undefined,
          'data',
          state.token,
        ),
      ]).then(res => {
        if (res[0] && res[0] !== null)
          dispatch({
            newAlerts: res[0],
          });
        else
          dispatch({
            newAlerts: [],
          });
        setIsWorking(false);
      });
    }
  }, [state.token, state.newAlerts, dispatch, state.user, isWorking]);
  React.useEffect(() => {
    setCurrPage(props.page);
  }, [props.page, setCurrPage]);
  const setCurrPage = React.useCallback(
    param => {
      dispatch({
        page: param,
      });
    },
    [dispatch],
  );
  const setLoading = status => {
    dispatch({
      loading: status,
    });
  };
  const toggleRightMenuVisibility = () => {
    dispatch({
      isRightMenuVisible:
        state.user === null ? false : !state.isRightMenuVisible,
    });
  };

  const params = useParams();
  const theme = useTheme();

  useEffect(() => {
    if (state.hasException) {
      // setTimeout(() => {
      //   dispatch({
      //     hasException: false,
      //     exception: undefined,
      //   });
      // }, 300);
      throw state.exception;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.hasException]);

  if (props.page === 'components') return <Components />;
  return (
    <>
      <MyView
        style={{
          flex: 1,
          backgroundColor: theme.colors.background.primary,
          overflowY:
            state.isInPhone && state.isRightMenuVisible ? 'hidden' : 'auto',
        }}>
        {allowRenderPage && (
          <MinFullHeightView>
            <MyView
              style={{
                flexDirection: 'row',
                flexWrap: 'wrap',
              }}>
              {state.isInPhone && state.showTopNav && (
                <Logo
                  toggleTheme
                  isLogin={state.user !== null}
                  toggleRightMenuVisibility={toggleRightMenuVisibility}
                />
              )}
              {!state.isInPhone &&
                props.page !== 'home' &&
                props.page !== 'allSchools' &&
                props.page !== 'rankingList' && (
                  <Logo
                    isLogin={state.user !== null}
                    toggleRightMenuVisibility={toggleRightMenuVisibility}
                  />
                )}
              {(props.page === 'home' ||
                props.page === 'allSchools' ||
                props.page === 'rankingList' ||
                state.user === null) &&
                !state.isInPhone && <Navbar user={state.user} />}

              {!state.isInPhone &&
                myAlerts !== undefined &&
                state.user !== null &&
                props.page !== 'home' &&
                props.page !== 'allSchools' &&
                props.page !== 'rankingList' && (
                  <Header
                    canRequestForAdv={canRequestForAdv}
                    pic={state.user.user.pic}
                    name={
                      state.user.user.firstName + ' ' + state.user.user.lastName
                    }
                    token={state.token}
                    isRightMenuVisible={state.isRightMenuVisible}
                    setLoading={setLoading}
                    navigate={navigate}
                    newAlerts={myAlerts}
                  />
                )}
              {!state.isInPhone &&
                props.page !== 'home' &&
                props.page !== 'buy' &&
                props.page !== 'allSchools' &&
                props.page !== 'rankingList' &&
                (myAlerts === undefined || state.user === null) && (
                  <div style={{width: 'calc(100% - 280px)'}}></div>
                )}

              <Menu
                isFilterAvailable={includeFilterMenu.indexOf(props.page) !== -1}
                toggleRightMenuVisibility={toggleRightMenuVisibility}
                navigate={navigate}
                selected={props.page}
                accesses={
                  state.user !== undefined &&
                  state.user !== null &&
                  state.user.accesses !== undefined
                    ? state.user.accesses
                    : null
                }
              />
              {props.page === 'home' && (
                <Home
                  isRightMenuVisible={state.isRightMenuVisible}
                  navigate={navigate}
                />
              )}

              {props.page === 'login' && !state.isInPhone && (
                <WebLogin navigate={navigate} />
              )}
              {props.page === 'login' && state.isInPhone && (
                <Login navigate={navigate} />
              )}

              {props.page !== 'home' && props.page !== 'login' && (
                <LargeContentConianer
                  showBackgroundColor={props.page !== 'rankingList'}
                  style={
                    !state.isInPhone &&
                    (state.isRightMenuVisible || state.isFilterMenuVisible)
                      ? {}
                      : state.isInPhone && state.isRightMenuVisible
                      ? PhoneContentConianerStyle2
                      : PhoneContentConianerStyle
                  }>
                  {/* {props.page === 'home' && <Gift navigate={navigate} />} */}
                  {props.page === 'profile' && (
                    <WebProfile
                      token={state.token}
                      user={state.user}
                      navigate={navigate}
                    />
                  )}
                  {props.page === 'dashboard' && !isUserAdvisor(state.user) && (
                    <Dashboard
                      token={state.token}
                      user={state.user}
                      navigate={navigate}
                    />
                  )}

                  {props.page === 'dashboard' && isUserAdvisor(state.user) && (
                    <AdvisorDashboard />
                  )}

                  {props.page === 'publicBadges' && (
                    <PublicBadges navigate={navigate} />
                  )}
                  {props.page === 'userVideos' && <UserVideos />}
                  {props.page === 'videos' && <Videos />}
                  {props.page === 'bookmarkedVideos' && (
                    <Videos justBookmarked={true} />
                  )}
                  {props.page === 'videoDetail' && <VideoDetail />}

                  {props.page === 'historyOfMyAdvisor' && (
                    <MyAdvisorHistory navigate={navigate} />
                  )}
                  {props.page === 'myComments' && (
                    <MyComments navigate={navigate} />
                  )}
                  {props.page === 'commentsAboutMe' && (
                    <CommentsAboutMe navigate={navigate} />
                  )}
                  {props.page === 'teacherProfile' && (
                    <TeacherProfile navigate={navigate} />
                  )}
                  {props.page === 'studentProfile' && (
                    <StudentProfile navigate={navigate} />
                  )}
                  {props.page === 'notif' && (
                    <SingleNotif navigate={navigate} />
                  )}
                  {props.page === 'showSchedule' && (
                    <ShowScheduleByUrlForStudent />
                  )}
                  {props.page === 'showScheduleForAdvisor' && (
                    <ShowScheduleByUrlForAdvisor />
                  )}
                  {props.page === 'invoice' && (
                    <Invoice
                      user={state.user}
                      token={state.token}
                      navigate={navigate}
                    />
                  )}
                  {props.page === 'myCerts' && <MyCerts navigate={navigate} />}
                  {props.page === 'validateCert' &&
                    params.certId !== undefined && (
                      <CheckCert navigate={navigate} />
                    )}
                  {props.page === 'buy' && <Buy />}
                  {props.page === 'buyIndividualQuiz' && (
                    <BuyIndividual
                      user={state.user}
                      token={state.token}
                      navigate={navigate}
                    />
                  )}
                  {props.page === 'onlineStandingQuizRegistration' && (
                    <BuyOnlineStanding navigate={navigate} />
                  )}
                  {props.page === 'schoolQuiz' && (
                    <MyQuizzes navigate={navigate} />
                  )}
                  {props.page === 'schoolHW' && (
                    <StudentHWs navigate={navigate} />
                  )}
                  {props.page === 'advisorQuiz' && (
                    <MyQuizzes advisor={true} navigate={navigate} />
                  )}
                  {props.page === 'courseIntroduction' && <CourseList />}
                  {props.page === 'packages' &&
                    params.sessionId !== undefined && (
                      <SessionDetail navigate={navigate} />
                    )}
                  {props.page === 'chatRoom' && (
                    <ChatRoom navigate={navigate} />
                  )}
                  {props.page === 'packages' &&
                    params.sessionId === undefined && (
                      <Packages isInMyMode={false} />
                    )}
                  {props.page === 'myPackages' && (
                    <Packages isInMyMode={true} />
                  )}
                  {props.page === 'karname' && (
                    <QuizProvider>
                      <ContentQuizKarname
                        quizId={params.quizId}
                        quizMode={params.mode}
                        studentId={params.studentId}
                        token={state.token}
                        user={state.user}
                        setLoading={setLoading}
                        setMode={() => navigate(-1)}
                        navigate={navigate}
                      />
                    </QuizProvider>
                  )}
                  {props.page === 'profileConfig' && (
                    <ProfileConfig navigate={navigate} />
                  )}
                  {props.page === 'contentFinalExam' && (
                    <RunQuiz
                      isInReviewMode={false}
                      token={state.token}
                      user={state.user}
                      navigate={navigate}
                    />
                  )}
                  {props.page === 'showAnswerSheet' && (
                    <AnswerSheet navigate={navigate} />
                  )}
                  {props.page === 'myTasks' && <MyTasks navigate={navigate} />}
                  {props.page === 'financeHistory' && (
                    <History navigate={navigate} />
                  )}
                  {props.page === 'allSchools' && (
                    <Schools navigate={navigate} />
                  )}
                  {props.page === 'recp' && (
                    <ShowRecp token={state.token} navigate={navigate} />
                  )}
                  {props.page === 'makeQuiz' && (
                    <MakeQuiz
                      user={state.user}
                      token={state.token}
                      navigate={navigate}
                    />
                  )}
                  {props.page === 'myCustomQuizzes' && (
                    <MyCustomQuizzes
                      user={state.user}
                      token={state.token}
                      navigate={navigate}
                    />
                  )}
                  {props.page === 'myIRYSCQuizzes' && (
                    <MyIRYSCQuizzes
                      user={state.user}
                      token={state.token}
                      navigate={navigate}
                    />
                  )}
                  {props.page === 'mySchoolQuizzes' && (
                    <MySchoolQuizzes navigate={navigate} />
                  )}
                  {props.page === 'mySchoolHWs' && (
                    <MyHWs navigate={navigate} />
                  )}
                  {props.page === 'startHW' && <DoHW navigate={navigate} />}
                  {props.page === 'startQuiz' &&
                    params.quizMode === 'onlineStanding' && (
                      <RunOnlineStandingQuiz
                        isInReviewMode={false}
                        navigate={navigate}
                      />
                    )}
                  {props.page === 'startQuiz' &&
                    params.quizMode === 'escape' && (
                      <RunEscapeQuiz
                        isInReviewMode={false}
                        navigate={navigate}
                      />
                    )}
                  {props.page === 'startQuiz' &&
                    params.quizMode.indexOf('pdf') !== -1 && (
                      <RunPDFQuiz isInReviewMode={false} navigate={navigate} />
                    )}
                  {props.page === 'startQuiz' &&
                    params.quizMode !== 'escape' &&
                    params.quizMode.indexOf('pdf') === -1 &&
                    params.quizMode !== 'onlineStanding' && (
                      <RunQuiz
                        isInReviewMode={false}
                        token={state.token}
                        user={state.user}
                        navigate={navigate}
                      />
                    )}
                  {props.page === 'checkCert' && (
                    <CheckCert navigate={navigate} />
                  )}
                  {props.page === 'rankingList' && <RankingList />}
                  {props.page === 'reviewQuiz' &&
                    params.quizMode === 'onlineStanding' && (
                      <RunOnlineStandingQuiz
                        isInReviewMode={true}
                        navigate={navigate}
                      />
                    )}
                  {props.page === 'reviewQuiz' &&
                    params.quizMode.indexOf('pdf') !== -1 && (
                      <RunPDFQuiz isInReviewMode={true} navigate={navigate} />
                    )}
                  {props.page === 'reviewQuiz' &&
                    params.quizMode.indexOf('pdf') === -1 &&
                    params.quizMode !== 'onlineStanding' && (
                      <RunQuiz
                        isInReviewMode={true}
                        token={state.token}
                        user={state.user}
                        navigate={navigate}
                      />
                    )}
                  {props.page === 'acceptInvite' && (
                    <AcceptInvite token={state.token} navigate={navigate} />
                  )}
                  {props.page === 'upgrade' && (
                    <Upgrade
                      token={state.token}
                      user={state.user}
                      navigate={navigate}
                    />
                  )}
                  {props.page === 'showAllTeachers' && (
                    <AllTeachers navigate={navigate} />
                  )}
                  {props.page === 'myTeachSchedules' && (
                    <MyTeachSchedule navigate={navigate} />
                  )}
                  {props.page === 'myTeachTransactions' && (
                    <MyTeachTransactions navigate={navigate} />
                  )}
                  {props.page === 'myTeachRequests' && (
                    <MyTeachRequests navigate={navigate} />
                  )}
                  {props.page === 'myTeachClasses' && (
                    <MyTeachClasses navigate={navigate} />
                  )}
                  {props.page === 'myScheduleRequests' && (
                    <MyScheduleRequests navigate={navigate} />
                  )}
                  {props.page === 'advisors' &&
                    state.user &&
                    state.user !== null && <Advisors independent={true} />}
                  {props.page === 'advisors' &&
                    (state.user === undefined || state.user === null) && (
                      <AdvisorsBeforeLogin independent={true} />
                    )}
                  {props.page === 'myAdvisor' && (
                    <MyAdvisor navigate={navigate} />
                  )}
                  {props.page === 'myLifeStyle' && <MyLifeStyle />}
                  {props.page === 'studentLifeStyle' && (
                    <MyLifeStyle navigate={navigate} />
                  )}
                  {props.page === 'studentProgress' && (
                    <Progress navigate={navigate} />
                  )}
                  {props.page === 'mySchedules' && (
                    <Schedule navigate={navigate} />
                  )}
                  {props.page === 'studentSchedules' && (
                    <Schedule navigate={navigate} />
                  )}
                  {props.page === 'myFinancePlans' && (
                    <MyFinancePlans navigate={navigate} />
                  )}
                  {props.page === 'myStudentRequests' && (
                    <MyRequests navigate={navigate} />
                  )}
                  {props.page === 'requestLogsForAdvisors' && (
                    <RequestLogsForAdvisors navigate={navigate} />
                  )}
                  {props.page === 'ranking' &&
                    params !== undefined &&
                    params.mode === 'onlineStanding' && (
                      <Ranking navigate={navigate} />
                    )}
                  {props.page === 'ticket' && (
                    <Ticketstd
                      token={state.token}
                      user={state.user}
                      navigate={navigate}
                    />
                  )}
                  {props.page === 'users' &&
                    params.level &&
                    params.level === 'school' && (
                      <SchoolUsers
                        token={state.token}
                        user={state.user}
                        navigate={navigate}
                      />
                    )}
                  {props.page === 'charge' && (
                    <ChargeAccount
                      token={state.token}
                      user={state.user}
                      navigate={navigate}
                    />
                  )}
                  {props.page === 'schoolUsers' && (
                    <SchoolUsers
                      token={state.token}
                      user={state.user}
                      navigate={navigate}
                    />
                  )}
                  {props.page === 'manageStudent' && <ManageStudents />}
                  {props.page === 'manageTeacher' && (
                    <ManageTeachers
                      token={state.token}
                      user={state.user}
                      navigate={navigate}
                    />
                  )}
                  {props.page === 'teachers' && (
                    <Teachers
                      token={state.token}
                      user={state.user}
                      navigate={navigate}
                    />
                  )}
                  {props.page === 'myOffs' && (
                    <MyOffs
                      token={state.token}
                      user={state.user}
                      navigate={navigate}
                    />
                  )}
                  {props.page === '404' && <PageNotFound navigate={navigate} />}
                </LargeContentConianer>
              )}
            </MyView>

            {state.isInPhone &&
              state.user === null &&
              excludeBottomNav.indexOf(props.page) === -1 && <BottomNavBar />}

            <ReactNotifications />
          </MinFullHeightView>
        )}
      </MyView>
    </>
  );
};
export default WebStructue;
